import React from 'react'
import { IntegrationsStickySec } from './integrationsStickySec'

export const IntegrationsSticky = () => {
  return (
    <IntegrationsStickySec />
  )
}
